import {TOKENS} from '../../tokens'

export const admonition = {
  dark: {
    tipColor: TOKENS.dark.positive_700,
    errorColor: TOKENS.dark.negative_500,
  },
  light: {
    tipColor: TOKENS.light.primary_500,
    errorColor: TOKENS.light.negative_500,
  },
} as const
